import { DatePicker as AntDatePicker } from 'antd';
import noop from 'lodash/noop';
import React from 'react';

import { ArrowRightOutlined } from '@ant-design/icons';

import styles from './styles/Calendar.less';

const { RangePicker } = AntDatePicker;
const DATE = 'date';

const Calendar = ({
  defaultValue,
  disabledDate,
  onChange,
  type,
  onCalendarChange,
  forceRender,
}) => {
  const onGetCalenderContainer = (trigger) => trigger.parentElement || document.body;

  if (type === DATE) {
    const extraProps = forceRender
      ? { key: `${defaultValue[0].format()}/${defaultValue[1].format()}` }
      : {};
    return (
      <div style={{ position: 'relative' }}>
        <RangePicker
          value={defaultValue}
          separator={<ArrowRightOutlined />}
          onChange={onChange}
          disabledDate={disabledDate}
          popupClassName={styles.empCalendar}
          onCalendarChange={onCalendarChange}
          open
          getPopupContainer={onGetCalenderContainer}
          placement={'bottomLeft'}
          className={styles.empRangePicker}
          {...extraProps}
        />
      </div>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      <AntDatePicker
        value={defaultValue[0]}
        onChange={onChange}
        popupClassName={styles.empCalendar}
        disabledDate={disabledDate}
        open
        showToday={false}
        getPopupContainer={onGetCalenderContainer}
      />
    </div>
  );
};

Calendar.defaultProps = {
  defaultValue: [],
  disabledDate: noop,
  onChange: noop,
  onCalendarChange: noop,
  type: 'date',
  forceRender: false,
};

export default Calendar;
